import dayjs from "dayjs";

type DateUnit = 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second';

export function countryToFlag(isoCode: string) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
      .toUpperCase()
      .replace(
        /./g,
        (char: any) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
      )
    : isoCode;
}

export const formatReceivedDate = (date: any) => {
  if (dayjs(date).isValid()) {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    if (dayjs(formattedDate).isValid()) {
      return formattedDate;
    }
  }
  return "";
};

export const formatNumber = (
  number: number, n: number
) => {
  const formattedNumber = number.toFixed(n);

  if (parseFloat(formattedNumber) === number) {
    return number;
  } else {
    return formattedNumber;
  }
}

export const formatDateDifference = (
  date1: Date, date2: Date
) => {
  const dateUnits: Array<DateUnit> = ['year', 'month', 'day', 'hour', 'minute', 'second'];
  for (let i = 0; i < dateUnits.length; i++) {
    const duration = dayjs(date1).diff(
      date2,
      dateUnits[i]
    );
    if (duration > 0) {
      return duration + ' ' + dateUnits[i] + 's';
    }
  }

  return "-";
}

export const getInputDateFormat = (lang: string) => {
  return lang === "en" ? "MM/dd/yyyy" : "dd.MM.yyyy";
};

export const isIterable = (obj:any) => {
  if (obj === null) {
    return false;
  }

  return typeof obj[Symbol.iterator] === 'function';
}

export const isSubmitButtonEnabled = (
  touched: any,
  errors: any,
  keys: string[]
) => {
  return isBeforeFirstSubmitPress(touched) || noErrors(
    errors,
    keys
  );
};

export const defaultCountryAutocompleteOption = {
  label: "",
  code: "",
};

const isBeforeFirstSubmitPress = (touched: any) => {
  return isEmptyObject(touched);
};

export const isEmptyObject = (obj: any) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    obj.constructor === Object
  );
}

const noErrors = (
  errors: any, keys: string[]
): boolean => {
  return keys.filter((key) => errors[key]).length === 0;
};

export const prune = (obj: any): any => {
  return typeof obj === 'object' ? Object.keys(obj).reduce(
    (
      result: any, key: string
    ) => obj[key] !== undefined && obj[key] !== null ? Object.assign(
      result,
      { [key]: typeof obj[key] === 'object' ? isIterable(obj[key]) ? obj[key].map((elem: any) => prune(elem)) : prune(obj[key]) : obj[key] }
    ) : result,
    {}
  ) : obj;
}

export const extract = (
  obj: any, keys: Array<string>
) => {
  return keys.reduce(
    (
      result: any, key: string
    ) => Object.assign(
      result,
      { [key]: obj[key] }
    ),
    {}
  );
}

export const toUpperCaseFirst = (text: string) : string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

